module.exports = __webpack_public_path__ + "static/assets/e0fe8d94b12137fb0257c4f2dd65837d.gif";